import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import React from 'react';
import { useTranslation } from "react-i18next";
import ScrollBox from '../../../components/ScrollBox';
import { formatBreakupDet, formatINRCurrency, getFormatedUnit } from '../../../utils/format';
import UnderLineTxt2 from '../../../components/UnderLineTxt2';

function ViewBreakup({ modalOpen, handleModalClose, shipmtData }) {
    const { t } = useTranslation();
    const boxStyle = { bgcolor: "rgba(0, 0, 0, 0.05)", borderRadius: 10, fontWeight: "600" }

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <Stack direction={'row'} alignItems={"center"} mb={1}>
                    <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>{t("bo.priceDet.priceDet")}</Typography>
                    <Typography sx={{ fontWeight: "bold", fontSize: 16, color: "rgba(0, 0, 0, 0.3)" }}>({shipmtData?.shipment?.shipmtId})</Typography>
                </Stack>
                <ScrollBox height={"85%"}>
                    <Stack alignItems="center">
                        <UnderLineTxt2 boxStyle={boxStyle} label={t("bo.priceDet.basePrc")} value={formatINRCurrency(shipmtData?.shipmtPricing?.basePrc)} line />
                        {(shipmtData?.shipmtPricingBreakup || []).map((i, index) => (
                            <Stack key={index}>
                                <UnderLineTxt2 boxStyle={boxStyle}
                                    label={(i?.breakup_detail === "aOthers" || i?.breakup_detail === "dOthers") ? `${formatBreakupDet(i?.breakup_detail)} (${i?.breakup_free_txt})` : formatBreakupDet(i?.breakup_detail)}
                                    value={`${i?.breakup_type === "addition" ? "+" : "-"}  ${formatINRCurrency(i?.breakup_amt)}`} line />
                            </Stack>
                        ))}
                        <StyleBox label={"Total Final Price"} value={formatINRCurrency(shipmtData?.shipmtPricing?.cust_finalPrc)} />
                        <StyleBox label={t("bo.priceDet.payTypeCust")} value={getFormatedUnit(shipmtData?.shipmtPricing?.custPayType)} />
                        {shipmtData?.shipmtPricing?.custPayType === "advance" && <StyleBox label={t("bo.priceDet.advAmt")} value={formatINRCurrency(shipmtData?.shipmtPricing?.advance)} />}
                    </Stack>
                </ScrollBox>
                <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={"100%"}>
                    <Button variant="contained" sx={{ height: 40, width: 120 }} onClick={handleModalClose}>{t("bo.priceDet.close")}</Button>
                </Stack>
            </Box>
        </Modal>
    )
}
export default ViewBreakup;

export function StyleBox({ label, value }) {
    return <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
            border: '2px solid #0D47A1',
            backgroundColor: '#E3F2FD',
            borderRadius: '16px',
            padding: 2, width: "100%", mb: 1
        }}>
        <Typography variant="subtitle1" fontWeight="bold" color="#0D47A1">
            {label}
        </Typography>
        <Typography variant="h6" fontWeight="bold" width={"45%"}>
            {value}
        </Typography>
    </Stack>
}

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 590,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 3,
    py: 2,
    borderRadius: 2,
    height: "90%"
};